import {
  toWords,
  TO_WORDS_BY_CURRENCY,
} from '@/utils/transactionbill/toWordsConfig';

// Indian-style number-to-words (works for NPR and INR).
// "Rupees Twelve Lakh Thirty-Four Thousand Five Hundred and Sixty-Seven Only"

const ONES = [
  '',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
  'Eleven',
  'Twelve',
  'Thirteen',
  'Fourteen',
  'Fifteen',
  'Sixteen',
  'Seventeen',
  'Eighteen',
  'Nineteen',
];
const TENS = [
  '',
  '',
  'Twenty',
  'Thirty',
  'Forty',
  'Fifty',
  'Sixty',
  'Seventy',
  'Eighty',
  'Ninety',
];

function twoDigit(n: number): string {
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return TENS[t] + (o ? '-' + ONES[o] : '');
}

function threeDigit(n: number): string {
  if (n < 100) return twoDigit(n);
  const h = Math.floor(n / 100);
  const r = n % 100;
  return ONES[h] + ' Hundred' + (r ? ' ' + twoDigit(r) : '');
}

export function numberToWordsIndian(
  amount: number,
  currency = 'Rupees',
  fractionUnit = 'Paisa',
): string {
  if (!isFinite(amount)) return '';
  const sign = amount < 0 ? 'Negative ' : '';
  amount = Math.abs(amount);

  const whole = Math.floor(amount);
  const frac = Math.round((amount - whole) * 100);

  if (whole === 0 && frac === 0) return `${currency} Zero Only`;

  let parts: string[] = [];

  const crore = Math.floor(whole / 10000000);
  const lakh = Math.floor((whole % 10000000) / 100000);
  const thousand = Math.floor((whole % 100000) / 1000);
  const hundred = whole % 1000;

  if (crore) parts.push(threeDigit(crore) + ' Crore');
  if (lakh) parts.push(twoDigit(lakh) + ' Lakh');
  if (thousand) parts.push(twoDigit(thousand) + ' Thousand');
  if (hundred) parts.push(threeDigit(hundred));

  let words = parts.join(' ').trim();
  if (!words) words = 'Zero';

  let result = `${currency} ${words}`;
  if (frac > 0) {
    result += ` and ${twoDigit(frac)} ${fractionUnit}`;
  }
  return sign + result + ' Only';
}

// `currency` is the document-wide currency prefix (e.g. "Nrs.", "$"); it selects
// the matching to-words converter. Unknown/empty falls back to the rupee config.
export function amountToWordsOrEmpty(raw: unknown, currency = ''): string {
  const str = `${raw ?? ''}`.replace(/,/g, '').trim();
  if (str === '') return '';
  const numeric = Number(str);
  if (!isFinite(numeric)) return '';
  const converter = TO_WORDS_BY_CURRENCY[currency] ?? toWords;
  try {
    return converter.convert(numeric, { currency: true });
  } catch {
    return '';
  }
}
